
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Plus, Check, X } from 'lucide-react';
import { useBoardContext } from '@/contexts/BoardContext';

export const CreateColumnButton = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [title, setTitle] = useState('');
  const [isCompleteColumn, setIsCompleteColumn] = useState(false);
  const { createColumn, creatingColumn, columns } = useBoardContext();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!title.trim()) return;

    // Calculate the next position
    const nextPosition = columns ? columns.length : 0;

    createColumn({
      title: title.trim(),
      position: nextPosition,
      is_completed_column: isCompleteColumn
    });

    setTitle('');
    setIsCompleteColumn(false);
    setIsCreating(false);
  };

  const handleCancel = () => {
    setTitle('');
    setIsCompleteColumn(false);
    setIsCreating(false);
  };

  if (isCreating) {
    return (
      <Card className="min-w-80 max-w-80 bg-white border-2 border-dashed border-gray-300">
        <CardContent className="p-4">
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Column title..."
              autoFocus
              className="border-gray-300"
            />
            
            <div className="flex items-center space-x-2">
              <Checkbox
                id="complete-column"
                checked={isCompleteColumn}
                onCheckedChange={(checked) => {
                  setIsCompleteColumn(checked === true);
                }}
              />
              <Label htmlFor="complete-column" className="text-sm">
                Completion column (triggers confetti)
              </Label>
            </div>

            <div className="flex gap-2">
              <Button
                type="submit"
                size="sm"
                disabled={!title.trim() || creatingColumn}
                className="flex-1"
              >
                {creatingColumn ? (
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
                ) : (
                  <Check className="h-4 w-4" />
                )}
              </Button>
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={handleCancel}
                className="flex-1"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    );
  }

  return (
    <Button
      variant="outline"
      onClick={() => setIsCreating(true)}
      className="min-w-80 max-w-80 h-12 border-2 border-dashed border-gray-300 text-gray-500 hover:border-gray-400 hover:text-gray-600"
    >
      <Plus className="h-4 w-4 mr-2" />
      Add Column
    </Button>
  );
};
